module.exports = __webpack_public_path__ + "assets/img/bb1b04f54f80e6d9b3ceb3f75171638e.png";